const V1_CS_EVENT = '/payments/digital/gravity/v1/cs/event';

const csEvent = ({
  acsTransId, token, gravityAuthnUrl, payload, updateDataHeader, dataHeader,
}) => {
  if (process.env.NODE_ENV === 'production') {
    const postUrl = `${gravityAuthnUrl}${V1_CS_EVENT}`;
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'acs-trans-id': acsTransId,
      Authorization: token,
    };
    if (dataHeader) headers.data = dataHeader;
    fetch(postUrl, {
      headers,
      method: 'POST',
      body: JSON.stringify(payload),
    })
      .then((res) => {
        const data = res.headers.get('data');
        if (data) updateDataHeader(data);
      })
      .catch(() => null);
  }
};

export default csEvent;
